import { DEFAULT_LANGUAGE } from '@dazn/lp-web/src/constants/defaults.constants';
import { userStatusTypes } from '../constants/userTypes.constants';

const CHAPTER_HISTORY = 'chapterHistory';
const CURRENT_CHAPTER = 'currentChapter';

const getDeviceInfo = () => window.dazn.startupData.UserDevice;

export const getDevicePlatform = () => window.dazn.device.platform;

const getChapterData = () => {
    return (window.dazn?.chapterHistory?.currentChapter as any)?.chapterData;
};
const logEvent = (eventName: string, additionalData: object): any => {
    window.newrelic?.addPageAction?.(eventName, { ...additionalData });
};

const getLanguage = () => {
    return (window.dazn && window.dazn.language) || DEFAULT_LANGUAGE;
};

const getTestingEnvironment = () => {
    return window?.dazn?.application?.environment;
};

export const getUserConsent = () => {
    return window?.dazn?.consent.getUserConsent();
};

const navigateToDifferentChapterUrl = ({
    chapterName,
    chapterPath,
    chapterData = getChapterData()
}: any) => {
    window.dazn[CHAPTER_HISTORY][CURRENT_CHAPTER] = {
        chapterName,
        ...(chapterPath ? { chapterPath } : {}),
        ...(chapterData ? { chapterData } : {})
    };
};

const getUserStatus = () =>
    window.dazn.userStatus || userStatusTypes.SIGNED_OUT;

const checkIsUserAnonymous = () =>
    getUserStatus() === userStatusTypes.SIGNED_OUT;

const getJWTToken = () => window?.dazn?.auth?.token || '';

const getAnonymousAuthToken = () => window.dazn?.auth?.anonymousToken;

const isNativeSession = () => window.dazn?.nativeSession?.isActive;

const getContentfulProxyConfig = () => window.dazn.getContentfulConfig();

const chapters = {
    AUTH: 'auth',
    SIGNIN: 'signin',
    CATALOG: 'catalog',
    OPENBROWSE: 'openbrowse',
    MY_ACCOUNT: 'account',
    HELP: 'help',
    ERROR: 'error',
    LANDINGPAGE: 'landingpage'
};

export {
    getDeviceInfo,
    navigateToDifferentChapterUrl,
    logEvent,
    getUserStatus,
    getLanguage,
    chapters,
    checkIsUserAnonymous,
    getJWTToken,
    getAnonymousAuthToken,
    getTestingEnvironment,
    isNativeSession,
    getContentfulProxyConfig
};
